/* eslint-disable */
import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import router from "./router";
import userService from "./services/userService";
import translationService from "./services/translationService";
import i18n from "./i18n";
import localUsers from "./users/user.json";
import LRS from "./services/lrsService";


Vue.use(Vuex);

export default new Vuex.Store({
    state: {
       user: localStorage.getItem("user") || "",
       translation: localStorage.getItem("translation") || "",
       lang: localStorage.getItem("lang") || "EN",
        country: localStorage.getItem("country") || "UK",
       chapters: localStorage.getItem("chapters") || "",
        moduleStatus: [],
        modulePercent: 0,
       modulename: localStorage.getItem("modulename") || "",
        seePinInfo: localStorage.getItem("seePinInfo") || 1,
        seeGiftInfo: localStorage.getItem("seeGiftInfo") || 1

    },
    mutations: {
        init(state, {user, translation, lang, chapters, module, moduleStatus,seePinInfo,seeGiftInfo}) {
            state.user = user;
            state.translation = translation;
            state.lang = lang;
            state.chapters = chapters;
            state.modulename = module;
            state.moduleStatus = moduleStatus;
            state.seePinInfo = seePinInfo;
            state.seeGiftInfo = seeGiftInfo;
        },
        setLanguage(state, {translations, lang}){
            state.translation = translations;
            state.lang = lang;
        },
        changeLanguage(state, {lang}){
            state.lang = lang;
            state.user.user.language = lang;
        },
        updateModuleStatus(state, chapter) {
            console.log('updateModuleStatus: ', chapter)
            let array = [chapter];
            let shouldBeAdded = true;

            for (let i = 0; i < state.moduleStatus.length; i++) {
                if(state.moduleStatus[i][0] == chapter){
                    shouldBeAdded = false;
                }
            }

            if (shouldBeAdded) {
                state.moduleStatus.push(array);
            }
        },
        updateModuleMastered(state, pinName){
            let u = state.user;

            if (typeof u === 'string' || u instanceof String){
                u = JSON.parse(u)
            }
            if(pinName == 'pin1'){
                u.pins["TokyoTour-1"] = 1;
            } else if(pinName == "pin2"){
                u.pins["TokyoTour-2"] = 1;
            }
        },
        updateModulePercent(state, progress) {
            console.log("Updating Progess done, ", progress)
            state.modulePercent = progress;
        },
        changeQuizStatus(state, {quizId, scored}){
            let u = state.user;

            if (typeof u === 'string' || u instanceof String){
                u = JSON.parse(u)
            }
            console.log(scored)
            u.quiz.attempts[quizId]++;
            if(quizId == 0){
                LRS.sendLRS('attempted01');
                LRS.sendLRS('scored01', scored*10);
                if(u.quiz.bestscore[0] < scored*10){
                    u.quiz.bestscore[0] = scored*10;
                }
                if(scored*10 >= 80){
                    u.quiz.successful[quizId] = 1;
                }
            } else if(quizId == 1){
                LRS.sendLRS('attempted02');
                LRS.sendLRS('scored02', scored*10);
                if(u.quiz.bestscore[1] < scored*10){
                    u.quiz.bestscore[1] = scored*10;
                }
                if(scored*10 >= 80){
                    u.quiz.successful[quizId] = 1;
                }
            } else if(quizId == 2){
                LRS.sendLRS('attempted03');
                LRS.sendLRS('scored03', scored*10);
                if(u.quiz.bestscore[2] < scored*10){
                    u.quiz.bestscore[2] = scored*10;
                }
                if(scored*10 >= 80){
                    u.quiz.successful[quizId] = 1;
                }
            } else if(quizId == 3){

                let points = 0;
                console.log(u)
                for (let i = 0; i < u.quiz.bestscore.length; i++) {
                    points += u.quiz.bestscore[i];
                }
                points = points / 3;
                console.log("Combined Quiz score", points)
                LRS.sendLRS('scored', points);
            }
        }
    },
    actions: {
        enterModule({ commit }, {module, lang, chapters}) {
            let user;
                userService.getUser(module).then(function (response) {
                    let data = response.data;
                    user = data;
                    console.log("User",data)
                    let lang = user.user.language;
                    let country = user.user.country;

                    let moduleStatus = [];
                    let progress = user.experienced;
                    progress.forEach(function (el) {
                        moduleStatus.push([el.id]);
                    });
                    let modulePercent = (progress.length / chapters) * 100;

                   /* if (user.user.is_member === 0) {
                        window.location.replace("https://www.discover-shiseido.com/uk_en/membersonly/");
                    }*/

                    translationService.getLanguage(module, country, lang).then(function (res) {
                        let translation = JSON.stringify(res.data);
                        let translationToInterpolate = res.data;

                        let interpolation = {
                            '{red}': '<span class="font-color-red">',
                            '{/red}': '</span>',
                            '{quote}': '"',
                            '{br}': '<br>',
                            '{bold}': '<strong>',
                            '{/bold}': '</strong>',
                            '{italic}': '<em>',
                            '{/italic}': '</em>',
                            '{uppercase}': '<span class="uppercase">',
                            '{/uppercase}': '</span>',
                            '{small}': '<small>',
                            '{/small}': '</small>',
                            '{sup}': '<sup>',
                            '{/sup}': '</sup>',
                            '{nobreak}': '<span class="nobr">',
                            '{/nobreak}': '</span>',
                            '{span}': '<span>',
                            '{/span}': '</span>',
                        }

                        Object.keys(translationToInterpolate).forEach(key => {
                            let value = translationToInterpolate[key];

                            //Für jeden Sprachschlüssel alle interpolations druch gehen
                            Object.entries(interpolation).forEach(entry => {
                                let interpolationKey = entry[0];
                                let interpolationValue = entry[1];
                                // hat Sprachschlüssel einen interpolation Tags?
                                if(value.indexOf(interpolationKey) !== -1){
                                    // Replace
                                    value = value.replace(new RegExp(interpolationKey, 'g'), interpolationValue);
                                    translationToInterpolate[key] = value;
                                }
                            });
                        });

                        translationToInterpolate = JSON.stringify(translationToInterpolate)

                        i18n.setLocaleMessage("en", JSON.parse(translationToInterpolate))
                        //console.log(i18n);
                        let seeGiftInfo = 1;
                        let seePinInfo = 1;
                        if(user.user.is_limited_to_lounge == 1){
                            // Sieht der User Pin & Gift Infos?
                            let validJBLCountry = ["DE","IT"];
                            let JBLNoPin = ["ES","NL","FR","PL","PT","CH","AT","CX"];
                            let JBLNoGift = ["NL", "AT", "CX"];
                            console.log(JBLNoPin.includes(user.user.country));
                            if(JBLNoPin.includes(user.user.language)){
                                seePinInfo = 0;
                            }
                            if(JBLNoPin.includes(user.user.country)){
                                seePinInfo = 0;
                            }
                            if(JBLNoGift.includes(user.user.language)){
                                seeGiftInfo = 0;
                            }
                            if(JBLNoGift.includes(user.user.country)){
                                seeGiftInfo = 0;
                            }

                        }
                        if(user.user.language == "NL" && user.user.is_douglas == 1){
                            seePinInfo = 0;
                            seeGiftInfo = 0;
                        }
                        seePinInfo = 0;

                        console.log(seePinInfo)
                        commit("init", {user, translationToInterpolate, lang,chapters, module, moduleStatus,seePinInfo,seeGiftInfo});
                        localStorage.setItem("user", JSON.stringify(user));
                        localStorage.setItem("translation", translationToInterpolate);
                        localStorage.setItem("lang", lang);
                        localStorage.setItem("chapters", chapters);
                        localStorage.setItem("moduleStatus", moduleStatus);
                        localStorage.setItem("modulePercent", modulePercent);
                        localStorage.setItem("modulename", module);
                        localStorage.setItem("seePinInfo", seePinInfo);
                        localStorage.setItem("seeGiftInfo", seeGiftInfo);

                       
                        

                        document.querySelector('.preloader').classList.add("hide");

                        LRS.sendLRS("launched");
                    })
                })


            // }


        },
        //#TODO: An User binden
        changeLanguage({commit}, {language}){
            commit("changeLanguage", {language});
            localStorage.setItem("lang", language);
            console.log("This ChangeLanguage: ", this)
            let c = this.getters.country;
            translationService.getLanguage('tokyotour.php', c, language).then(function (res) {
                let translation = JSON.stringify(res.data);
                console.log(translation);
                let translationToInterpolate = res.data;

                let interpolation = {
                    '{red}': '<span class="font-color-red">',
                    '{/red}': '</span>',
                    '{quote}': '"',
                    '{br}': '<br>',
                    '{bold}': '<strong>',
                    '{/bold}': '</strong>',
                    '{italic}': '<em>',
                    '{/italic}': '</em>',
                    '{uppercase}': '<span class="uppercase">',
                    '{/uppercase}': '</span>',
                    '{small}': '<small>',
                    '{/small}': '</small>',
                    '{sup}': '<sup>',
                    '{/sup}': '</sup>',
                    '{nobreak}': '<span class="nobr">',
                    '{/nobreak}': '</span>',
                    '{span}': '<span>',
                    '{/span}': '</span>',
                }

                Object.keys(translationToInterpolate).forEach(key => {
                    let value = translationToInterpolate[key];

                    //Für jeden Sprachschlüssel alle interpolations druch gehen
                    Object.entries(interpolation).forEach(entry => {
                        let interpolationKey = entry[0];
                        let interpolationValue = entry[1];
                        // hat Sprachschlüssel einen interpolation Tags?
                        if(value.indexOf(interpolationKey) !== -1){
                            // Replace
                            value = value.replace(new RegExp(interpolationKey, 'g'), interpolationValue);
                            translationToInterpolate[key] = value;
                        }
                    });
                });

                translationToInterpolate = JSON.stringify(translationToInterpolate)

                i18n.setLocaleMessage("en", JSON.parse(translationToInterpolate))
                //console.log(i18n);

                commit("setLanguage", {translationToInterpolate, language});
                localStorage.setItem("translation", translationToInterpolate);

            })
        },
        sendQuizAttempt({commit}, {quizId, scored}){
            console.log("Change Quiz Status:" , quizId, scored)
            commit("changeQuizStatus", {quizId, scored});
        },
        updateModuleStatus({commit}, chapter){
            commit("updateModuleStatus", chapter);
        },
        updateModulePercent({commit}, progress) {
            console.log("Module Percent Update; ", progress)
            commit("updateModulePercent", progress);
        },
        updateModuleMastered({commit}, pinID){
            commit("updateModuleMastered", pinID);
        }
    },
    getters: {
        user(state){
            return state.user;
        },
        moduleStatus(state) {
            return state.moduleStatus;
        },
        modulePercent(state) {
            return state.modulePercent;
        },
        translation(state){
            return state.translation;
        },
        lang(state){
            return state.lang;
        },
        country(state) {
            return state.country;
        },
        maxChapters(state){
            return state.chapters;
        },
        modulename(state){
            return state.modulename;
        },
        seeGiftInfo(state){
            return state.seeGiftInfo;
        },
        seePinInfo(state){
            return state.seePinInfo;
        }
    }
});